export default "__VITE_ASSET__BVvuk1SB__"